import { Copy } from 'lucide-react';

interface OrderInfoProps {
  id: string;
  paymentMethod?: string;
  paidAt?: string;
  onCopyOrderId: () => void;
}

export default function OrderInfo({ id, paymentMethod, paidAt, onCopyOrderId }: OrderInfoProps) {
  return (
    <div className="space-y-4 p-4 bg-white">
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Delivery time</span>
        <span>-</span>
      </div>
      <div className="flex justify-between text-sm">
        <span className="text-gray-500">Completed time</span>
        <span>-</span>
      </div>
    </div>
  );
} 